/**
 * DateTimeConfig - Configuration for date/time pickers.
 * Centralizes picker options for consistency and maintainability.
 */

// import { ValueStrings } from "../../utils/constantsString";

export const MAX_YEARS_IN_PICKER = 10;
export const TIME_INTERVAL = 15;

export const DatePickerConfig = {
  // dateFormat: ValueStrings.DATE_FORMAT_SMALL,
  showYearDropdown: true,
  showMonthDropdown: true,
  yearDropdownItemNumber: MAX_YEARS_IN_PICKER,
  isClearable: true,
  showPopperArrow: false,
  popperPlacement: "bottom-start",
  // placeholderText: ValueStrings.dateFormat
};

